<template>
  <div class="license">
    <van-tabs sticky>
      <van-tab title="资质证书" v-if="type===0">
        <div class="img_wrap" v-for="(item, index) in ImgData" :key="index">
          <div class="img_title">{{ item.title }}</div>
          <van-image width="100%" :src="`${item.url}?t=${timestamp}`" />
        </div>
      </van-tab>
      <van-tab title="其他资质" v-if="type===0">
        <van-cell-group>
          <van-cell @click="click(item)" v-for="(item, index) in ImgData" :key="index">
            <template #title>
              <div>{{ item.title }}</div>
              <div v-if="item.subTitle">{{ item.subTitle }}</div>
            </template>
          </van-cell>
        </van-cell-group>
      </van-tab>
      <van-tab title="质量公告">
        <div class="pad">
          <van-cell-group>
            <van-cell @click="jump(item)" v-for="(item, index) in data" :key="index" :title="`${item.typeName}`" />
          </van-cell-group>
        </div>
      </van-tab>
    </van-tabs>
    <van-overlay :show="show" @click="show = false" lock-scroll>
      <div class="wrapper">
        <van-image width="100%" :src="`${selectItem.url}?t=${timestamp}`" />
        <div style="color:#fff" class="img_title">{{ selectItem.title }}</div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import Vue from "vue";
import { Image as VanImage, Tab, Tabs, Cell, CellGroup, Overlay } from "vant";
import { getImgUrl } from "@/utils/tools";
import { post } from "@/utils/request";
import { goToApp } from '@/utils/userInfo';
import { meBaseUrl } from '@/constant' 
import ImgData from './data'
Vue.use(VanImage);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Overlay);
export default {
  props: {},
  data() {
    return {
      ImgData,
      show: false,
      selectItem: {},
      data: [],
      type: 0,
      showType: 2,
      timestamp: +new Date()
    };
  },
  components: {

  },
  created() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
    }
    if (this.$route.query.showType) {
      this.showType = this.$route.query.showType
    }

    if (this.showType == 2) {
      this.ImgData = this.ImgData.filter(item => item.showType === 2)
    }

    post({
      url: '/article/open/articleType/findArticleType',
      data: {
        location: 64
      }
    }).then(res => {
      if (res.code === 0) {
        this.data = res.data
      }
    })
  },
  methods: {
    getImgUrl,
    click(item) {
      this.show = true
      this.selectItem = item
    },
    jump(item) {
      if (!this.$store.state.appInfo.isApp) {
        this.$router.push(`/web/article?articleTypeId=${item.idStr}&_immersive=0&title=${encodeURIComponent(item.typeName)}`)
      } else {
        goToApp(`${meBaseUrl}/web/article?articleTypeId=${item.idStr}&_immersive=0&title=${encodeURIComponent(item.typeName)}`)
      }
    }
  },
};
</script>

<style>
.van-overlay {
  z-index: 9999;
}
.pad .van-cell {
  padding: 20px 16px
}
</style>

<style lang="scss" scoped>
.license {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  // background-color: #ffffff;
  .img_wrap {
    padding: 10px;
  }

  .img_title {
    text-align: center;
    padding: 10px 0;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
</style>
